var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { terms } from '../../../models';
import CheckTerm from '../../atoms/CheckTerm';
import { CheckboxFill, CheckboxLine, neutralDay, mBody1 } from '@teamsparta/design-system';
import { useEffect, useState } from 'react';
import { ButtonWithoutStyle } from '../../../styles/_common.style';
var AgreeTerms = function (_a) {
    var agreements = _a.agreements, updateAgreements = _a.updateAgreements;
    var _b = useState(false), isAllSelected = _b[0], setIsAllSelected = _b[1];
    useEffect(function () {
        setIsAllSelected(Object.values(agreements).every(function (checked) { return checked; }));
    }, [agreements]);
    var onClickCheckTerm = function (key) {
        var _a;
        updateAgreements(__assign(__assign({}, agreements), (_a = {}, _a[key] = !agreements[key], _a)));
    };
    var onClickAgreeAll = function () {
        var newAgreements = __assign({}, agreements);
        Object.keys(newAgreements).forEach(function (key) {
            newAgreements[key] = !isAllSelected;
        });
        updateAgreements(newAgreements);
    };
    return (_jsxs(Container, { children: [_jsxs(AgreeAllContainer, __assign({ onClick: onClickAgreeAll }, { children: [isAllSelected ? (_jsx(CheckboxFill, { size: 20, primaryColor: neutralDay.gray100, secondaryColor: neutralDay.white })) : (_jsx(CheckboxLine, { size: 20, color: neutralDay.gray60 })), "\uC804\uCCB4 \uC57D\uAD00 \uB3D9\uC758"] })), _jsx(CheckTerms, { children: terms.map(function (term) { return (_jsx(CheckTerm, { termData: term, isChecked: agreements[term.key], setIsChecked: function () { return onClickCheckTerm(term.key); } }, term.key)); }) })] }));
};
export default AgreeTerms;
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  align-items: flex-start;\n"], ["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  align-items: flex-start;\n"])));
var AgreeAllContainer = styled(ButtonWithoutStyle)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  ", ";\n  color: ", ";\n"], ["\n  cursor: pointer;\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  ", ";\n  color: ", ";\n"])), mBody1, neutralDay.gray100);
var CustomCheckbox = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 15px;\n  height: 15px;\n  border: 2px solid ", ";\n  border-radius: 3px;\n"], ["\n  width: 15px;\n  height: 15px;\n  border: 2px solid ", ";\n  border-radius: 3px;\n"])), neutralDay.gray60);
var CheckTerms = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=AgreeTerms.js.map